import { FormFieldValue, OrderCompositeField } from '../types';
import { TextFormFieldValidator } from './TextFormFieldValidator';

export class OrderNumberFormatValidator extends TextFormFieldValidator {
  static ORDER_ID_REGEX_PATTERN = /^\d+(?:-[A-Z])?$/;

  protected isValid(value: FormFieldValue) {
    const suborderId = (value as OrderCompositeField).suborderId;
    return this.isEmpty(suborderId)
      ? this.requiredCheck(suborderId)
      : this.requiredCheck(suborderId) &&
          this.lengthCheck(suborderId) &&
          OrderNumberFormatValidator.ORDER_ID_REGEX_PATTERN.test(suborderId);
  }
}
